// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:22:39

export default {
  "id": "easy-obby-jump-and-run-challenge-online",
  "slug": "easy-obby-jump-and-run-challenge-online",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d414ff5e4e1d4dbaa67e7e3ddd1364b9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d414ff5e4e1d4dbaa67e7e3ddd1364b9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Easy Obby Jump and Run Challenge Online",
      "description": "Easy Obby: Jump and Run Challenge Online is a highly dynamic game where you jump across platforms, climbing higher and higher! Overcome tricky traps, avoid dangerous obstacles and prove that your reflexes are at their best. Can you make it to the top? ",
      "instructions": "PC:\nWASD - move\nSpace - jump\nTAB - pause\nF - dash  \nShift - show cursor \nMouse wheel forward/backward - zoom in/out the camera\nHold RMB to rotate the camera \n\nMobile: \nUse the game interface",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "3d",
        "climbing",
        "jumping",
        "multiplayer",
        "platformer"
      ]
    },
    "zh-CN": {
      "title": "简单奥比跳跃和跑酷挑战在线",
      "description": "简易奥比：跳跃与奔跑挑战在线是一款高度动态的游戏，你在平台上跳跃，不断攀登更高！克服棘手的陷阱，避开危险障碍，证明你的反应速度处于最佳状态。你能到达顶端吗？",
      "instructions": "PC:\nWASD - 移动\n空格 - 跳跃\nTAB - 暂停\nF - 疾跑  \nShift - 显示光标 \n鼠标滚轮前后 - 缩放相机\n按住右键旋转相机 \n\nMobile: \n使用游戏界面",
      "genres": [
        "冒险"
      ],
      "tags": [
        "三维",
        "攀爬",
        "跳跃",
        "多人游戏",
        "平台游戏"
      ]
    },
    "zh-TW": {
      "title": "簡單奧比跳躍跑挑戰在線",
      "description": "Easy Obby: 網上跳躍挑戰遊戲是一個高度動態的遊戲，您需要在平台上跳躍，漲到更高的地方！克服困難陷阱，避開危險障礙，證明您的反應最為敏捷。你能夠達到頂端嗎？",
      "instructions": "PC:\nWASD - 移動\n空格鍵 - 跳躍\nTAB - 暫停\nF - 飄移  \nShift - 顯示光標 \n滑鼠滾輪向上/向下 - 詳細度進/退\n按住右鍵滑鼠輪 - 旋轉相機 \n\n手機:\n使用遊戲介面",
      "genres": [
        "冒險"
      ],
      "tags": [
        "3D",
        "攀爬",
        "跳躍",
        "多人遊戲",
        "平台遊戲"
      ]
    },
    "zh-HK": {
      "title": "易跳易跑挑戰在線",
      "description": "Easy Obby: 積極跳躍挑戰在線是一款極具動態感的遊戲，你將在平台上跳躍，越爬越高！克服複雜的陷阱，避開危險的障礙，證明你的反應速度達到最佳狀態。你能夠到達頂端嗎？",
      "instructions": "PC:\nWASD - 移動\n空格 - 跳躍\nTAB - 暂停\nF - 疾走  \nShift - 開啟光標 \n滑鼠滾輪向前/後退 - 放大/縮小鏡頭\n按住右鍵滑鼠輪旋轉鏡頭 \n\nMobile: \n使用遊戲介面",
      "genres": [
        "冒險"
      ],
      "tags": [
        "3D",
        "攀爬",
        "跳躍",
        "多人遊戲",
        "平台遊戲"
      ]
    },
    "ja": {
      "title": "簡単オビージャンプアンドランチャレンジオンライン",
      "description": "Easy Obby:ジャンプ＆ランチャレンジオンラインは、プラットフォームをジャンプし、どんどん高く登っていく非常にダイナミックなゲームです！難しい罠を乗り越え、危険な障害物を避け、反射神経が最高の状態であることを証明しましょう。最上階に到達できるでしょうか？",
      "instructions": "PC:\nWASD - 移動\nSpace - 跳躍\nTAB - ポーズ\nF - ダッシュ\nShift - カーソル表示\nマウスホイールの前後 - カメラのズームイン/アウト\n右クリックを長押ししてカメラを回転\n\nMobile:\nゲームインターフェースを使用",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "3D",
        "クライミング",
        "ジャンプ",
        "マルチプレイヤー",
        "プラットフォームゲーム"
      ]
    },
    "ko": {
      "title": "어이 있는 오비 점프와 달리기 도전 온라인",
      "description": "Easy Obby: Jump and Run Challenge Online은 플랫폼을 건너며 점점 더 높이로 오르는 매우 동적이고 흥미로운 게임입니다! 어려운 트랩을克服하고 위험한 장애물을 피하며 당신의 반사신경이 최상이지 않을까요? 정상에 도달할 수 있을까요?",
      "instructions": "PC:\nWASD - 이동\nSpace - 점프\nTAB - 일시정지\nF - 스플래시  \nShift - 커서 표시 \n마우스 휠 상하 - 카메라 줌 인/아웃\n좌鼠标 중지 버튼을 눌러 카메라를 회전하려면\n\nMobile: \n게임 인터페이스 사용",
      "genres": [
        "모험"
      ],
      "tags": [
        "3D",
        "등반",
        "점프",
        "멀티플레이어",
        "플랫폼어"
      ]
    },
    "fr": {
      "title": "Facile Obby Saut et Course Défi En Ligne",
      "description": "Easy Obby : Défis de Saut et de Course En Ligne est un jeu très dynamique où vous sautez d'une plate-forme à l'autre, grimpez toujours plus haut ! Surmontez des piéges délicats, évitez des obstacles dangereux et prouvez que vos réflexes sont à leur meilleur. Pouvez-vous atteindre le sommet ?",
      "instructions": "PC :\nWASD - se déplacer\nEspace - sauter\nTAB - mettre en pause\nF - sprint  \nMaj - afficher le curseur \nRoue de la souris avant/arrière - zoom avant/zoom arrière de la caméra\nMaintenir le clic droit pour faire pivoter la caméra \n\nMobile :\nUtilisez l'interface de jeu",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "3D",
        "grimpe",
        "saut",
        "multijoueur",
        "plate-forme"
      ]
    }
  }
};
